// https://github.com/equinox-platformx/api.account/blob/master/src/main/java/com/equinoxfitness/account/util/AccountExceptionMessage.java

export const CURRENT_PASSWORD_IS_MISSING = 1015;
export const NEW_PASSWORD_IS_MISSING = 1016;
export const PASSWORD_LENGTH_INCORRECT = 1017;
export const PASSWORD_IS_INVALID = 1018;
export const FALIED_TO_CHANGE_PASSWORD = 1019;
export const PASSWORD_FORMAT_INCORRECT = 1022;
